// removed by extract-text-webpack-plugin
module.exports = {"text":"style__text__3q5gB","sidebar":"style__sidebar__2Nd3I","sidebarMargin":"style__sidebarMargin__25Wgv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/subscriptions/modal/style.scss
// module id = 1074
// module chunks = 0